import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { Form } from "react-final-form";
import { DotLoader } from "react-spinners";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { consultarEmpresasSAT, descargarXLSEmpresas, limpiarMensajesEmpresas } from "../modulos/empresasTrasladadasActions";
import { Mensaje } from "../../../general/componentes/Mensaje";
import DatePickerSura from "../../../general/componentes/DatePicker";
import { FiltroEmpresas } from "../modelo/EmpresasTrasladadas";
import TablaEmpresasTrasladadas from "./TablaEmpresasTrasladadas";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { fechaFinalEmpresasTrasladadas, fechaInicialEmpresasTrasladadas, tipoConsultaEmpresas } from "../../config_general/modelo/TextosAyuda";
import NumericInput from "../../../general/componentes/NumericInput";
import { TipoConsulta } from "../modelo/TipoConsulta";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";

class EmpresasTrasladadas extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
    }

    componentWillUnmount() {
        const { datosEmpresas } = this.props;
        if (!datosEmpresas || !datosEmpresas.length) this.props.dispatch(limpiarMensajesEmpresas());
    }

    render() {
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Empresas Trasladadas</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar reporte con rango de fecha</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoConsulta">Consultar por:</label>
                                                <TextoAyuda texto={tipoConsultaEmpresas} />
                                                <TextoInputSelector name="tipoConsulta" maestro={this.listarTipoConsulta()} />
                                                {errors.tipoConsulta &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoConsulta}</span>
                                                    </div>
                                                }
                                            </Col>
                                            {
                                                values.tipoConsulta &&
                                                this.renderOpcionesConsulta(Number(values.tipoConsulta.value))
                                            }
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {
                                                        (this.props.datosEmpresas) &&
                                                        <a className="btns btn-success" onClick={() => this.descargarXLSEmpresas()}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderPestañaEstructuraEmpresa()}
                </Row>
            </div>
        );
    }

    renderOpcionesConsulta(codigoConsulta: number) {
        switch (codigoConsulta) {
            case 1:
                return (
                    <Col sm={3}>
                        <label htmlFor="consecutivoConsulta">Consecutivo Consulta</label>
                        <NumericInput name="consecutivoConsulta" placeholder="Ingrese un consecutvio" />
                    </Col>
                );
            case 2:
                return (
                    <div>
                        <Col sm={3}>
                            <label>Fecha Inicial consulta</label>
                            <TextoAyuda texto={fechaInicialEmpresasTrasladadas} />
                            <DatePickerSura name={"fechaInicial"} />
                        </Col>
                        <Col sm={3}>
                            <label>Fecha Final consulta</label>
                            <TextoAyuda texto={fechaFinalEmpresasTrasladadas} />
                            <DatePickerSura name={"fechaFinal"} />
                        </Col>
                    </div>
                );
            default:
                return false;
        }
    }

    renderPestañaEstructuraEmpresa() {
        const { estadoConsulta, mensajeUsuario, datosEmpresas, error, consecutivoProceso } = this.props;

        switch (estadoConsulta) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                if (error)
                    return (
                        <span>
                            <Mensaje type={"danger"} mensaje={` Ocurrio un error durante la consulta con consecutivo ${consecutivoProceso}`} />
                        </span>
                    );
                if (!datosEmpresas || !datosEmpresas.length)
                    return (
                        <span>
                            <Mensaje type={"success"} mensaje={` La consulta se encuentra en tramite con el consecutivo ${consecutivoProceso}`} />
                        </span>
                    );
                else
                    return (
                        <span>
                            {datosEmpresas.length > 3000 &&
                                <Mensaje type={"warning"} mensaje='La información retornada por SAT excede el límite establecido
                                de la consulta, para visualizar los demás registros se debe cerrar el rango de fechas.' />
                            }
                            <TablaEmpresasTrasladadas
                                consecutivoProceso={consecutivoProceso}
                                datosEmpresas={datosEmpresas}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    validate = (values: any) => {
        const errors = {
            tipoConsulta: undefined,
            consecutivoConsulta: undefined,
            fechaInicial: undefined,
            fechaFinal: undefined
        };

        if (!values.tipoConsulta)
            errors.tipoConsulta = "Por favor seleccione una de las opciones";

        if (values.tipoConsulta && values.tipoConsulta.value === 1 && !values.consecutivoConsulta)
            errors.consecutivoConsulta = "Por favor ingrese el consecutivo de la consulta realizada";

        if (values.tipoConsulta && values.tipoConsulta.value === 2) {

            if (!values.fechaInicial)
                errors.fechaInicial = "Por favor seleccione la fecha incial";

            if (values.fechaInicial && !values.fechaFinal)
                errors.fechaFinal = "Por favor seleccione la fecha final";

            if (values.fechaInicial && values.fechaFinal && values.fechaInicial.isAfter(values.fechaFinal)) {
                errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";
            }
        }

        return errors;
    };

    onSubmit = (values: any) => {
        const consecutivoConsulta = values.consecutivoConsulta && values.tipoConsulta.value === 1 ? values.consecutivoConsulta : undefined;
        const fechaInicial = values.fechaInicial && values.tipoConsulta.value === 2 ? values.fechaInicial.valueOf() : "";
        const fechaFinal = values.fechaFinal && values.tipoConsulta.value === 2 ? values.fechaFinal.valueOf() : "";

        const filtroEmpresas: FiltroEmpresas = {
            consecutivoConsulta: consecutivoConsulta,
            usuario: this.props.dniUsuarioGestionLogin,
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal
        };

        this.props.dispatch(consultarEmpresasSAT(filtroEmpresas));
    };

    descargarXLSEmpresas() {
        if (this.props.datosEmpresas) {
            this.props.dispatch(descargarXLSEmpresas(this.props.datosEmpresas));
        }
    }

    listarTipoConsulta = () => {
        return [].concat(
            TipoConsulta.map(value => ({
                value: value.codigo,
                label: value.opcion
            })
            ));
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estadoConsulta: R.pathOr([], ["empresas_trasladadas", "estadoConsulta"])(store),
        datosEmpresas: R.pathOr(undefined, ["empresas_trasladadas", "datosEmpresas"])(store),
        consecutivoProceso: R.pathOr(undefined, ["empresas_trasladadas", "consecutivoProceso"])(store),
        error: R.pathOr(undefined, ["empresas_trasladadas", "error"])(store),
        mensajeUsuario: R.pathOr(undefined, ["empresas_trasladadas", "mensajeUsuario"])(store)
    };
})(EmpresasTrasladadas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/empresas_trasladadas/componentes/EmpresasTrasladadas.tsx